import React from 'react';
import Select from 'react-select';

const hiddenDisplay = {
  display: 'none',
};

const whiteInput = {
  color: '#fff',
};

const inputPx = 12;
const inputPy = 20;

const styles = {
  container: () => ({ border: '1px solid #5b5b5b', borderRadius: '5px' }),
  selectContainer: () => ({ borderRadius: '5px' }),
  indicatorSeparator: () => hiddenDisplay,
  input: () => whiteInput,
  singleValue: () => ({
    ...whiteInput,
    overFlow: 'hidden',
    position: 'absolute',
    top: '50%',
    transform: 'translateY(-50%)',
    opacity: 0.7,
  }),
  valueContainer: () => ({ padding: `${inputPx}px ${inputPy}px`, fontSize: '20px', color: '#fff' }),
  control: () => ({ backgroundColor: 'transparent', display: 'flex', justifyContent: 'space-between' }),
};

export default function SelectField(props) {
  // eslint-disable-next-line react/prop-types
  return <Select {...props} styles={{ ...styles, ...props?.styles, padding: '0' }} className="select-input" />;
}
